import { DatePicker } from "antd";
import { Modal } from "../../commonComponents";
import InfoText from "../../commonComponents/InfoText/InfoText";
import MondayButton from "../../commonComponents/MondayButton/MondayButton";
import { useSelector } from "react-redux";
import dayjsTZ from "../../../utils/dayjs";

const RangeFilterModal = ({
  open,
  setOpen,
  activeFilter,
  setActiveFilter,
  onFetch = () => {},
}) => {
  const { isDarkMode } = useSelector((state) => state.usersList);

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      title="Zgjidh periudhën"
      footer={[
        <MondayButton
          key={0}
          className="mondayButtonRed"
          onClick={() => setOpen(false)}
        >
          Anullo
        </MondayButton>,
        <MondayButton
          key={1}
          className="mondayButtonGreen"
          onClick={() => onFetch()}
        >
          Filtro
        </MondayButton>,
      ]}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <InfoText text="Zgjidh periudhën në të cilën do të filtrosh turnet" />
        <div style={{ display: "flex", gap: 10 }}>
          <DatePicker
            placeholder="Fillimi"
            value={activeFilter[0]}
            popupClassName={isDarkMode ? "darkDropdown" : ""}
            onChange={(val) => {
              setActiveFilter(([_, end]) => {
                if (end && val && dayjsTZ(val).isAfter(end)) {
                  return [val, null];
                }
                // if (
                //   end &&
                //   val &&
                //   dayjsTZ(end).diff(dayjsTZ(val), "month", true) > 4
                // ) {
                //   message.error("Intervali maksimal është 4 muaj.");
                //   return [val, null];
                // }
                return [val, end];
              });
            }}
            allowClear={false}
            format={"DD/MM/YYYY"}
          />
          <DatePicker
            value={activeFilter[1]}
            placeholder="Mbarimi"
            popupClassName={isDarkMode ? "darkDropdown" : ""}
            onChange={(val) => {
              setActiveFilter(([start, _]) => {
                if (start && val && dayjsTZ(val).isBefore(start)) {
                  return [start, null];
                }
                // if (
                //   start &&
                //   val &&
                //   dayjsTZ(val).diff(dayjsTZ(start), "month", true) > 4
                // ) {
                //   message.error("Intervali maksimal është 4 muaj.");
                //   return [start, null];
                // }
                return [start, val];
              });
            }}
            allowClear={false}
            format={"DD/MM/YYYY"}
          />
        </div>
      </div>
    </Modal>
  );
};

export default RangeFilterModal;
